<script setup lang="ts">
import { useStorage } from '@vueuse/core';
import type { RouteLocationRaw } from 'vue-router';
import slugify from '@sindresorhus/slugify';
import { getEmptySearchCriteria, type PropertySearchCriteria, propertyTypeToSearchCriteria } from '@@/shared/property/search-criteria';
import { getUrlParamsFromCriteria } from '@@/shared/property/url-serp';
import type { PropertyOnPage } from '@@/shared/property/api-types';
import type { IadAppRoute } from '~/application';

const props = defineProps<{
  property: PropertyOnPage
}>();

// BACK LINK
const { locale } = useI18n();
const isMounted = useMounted();
const returnTo = useStorage(`property-${props.property.propertyListingRef}`, ``);
const backLink = computed<IadAppRoute<`serp-serpSlug`> | RouteLocationRaw>(() => {
  if (isMounted.value && returnTo.value) return returnTo.value;
  const criteria: PropertySearchCriteria = {
    ...getEmptySearchCriteria(),
    transactionType: props.property.transactionType,
    locations: [slugify(`${props.property.location.place} ${props.property.location.postcode}`)],
    propertyTypes: propertyTypeToSearchCriteria(props.property.propertyType),
  };
  const urlParams = getUrlParamsFromCriteria(locale.value, criteria);
  return {
    name: 'serp-serpSlug',
    params: { serpSlug: urlParams.serpSlug },
    query: urlParams.query,
  };
});

const emit = defineEmits<{
  share: []
}>();
</script>

<template>
  <div class="flex justify-between pb-xl">
    <div>
      <ClientOnly>
        <IadBtn
          icon
          variant="outlined"
          :to="backLink"
        >
          <Icon name="iad-icon:arrow-left" />
        </IadBtn>
      </ClientOnly>
    </div>
    <div class="flex gap-xs">
      <IadBtn
        icon
        variant="outlined"
        @click="emit('share')"
      >
        <Icon name="iad-icon:share" />
      </IadBtn>
    </div>
  </div>
</template>
